<template>
    <section
        v-if="isValidCalendlyUrl"
        :id="slice.primary.anchorId || undefined"
        :data-slice-type="slice.slice_type"
        :data-slice-variation="slice.variation"
        class="slice slice-embeded slice-embeded--embeded-calendly"
        aria-label="calendly"
        data-testid="slice-embeded-calendly"
    >
        <div class="slice-content">
            <PrismicRichText v-if="slice.primary.title" class="slice-title" :field="slice.primary.title" data-testid="slice-embeded-calendly-title" />
            <PrismicRichText
                v-if="slice.primary.description"
                class="slice-description"
                :field="slice.primary.description"
                data-testid="slice-embeded-calendly-description"
            />
            <div class="calendly-inline-widget" :data-url="calendlyUrl" data-resize="true" data-testid="slice-embeded-calendly-widget" />
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed, onMounted} from 'vue';
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {EmbededSlice} from '@prismicio-types';

    type EmbededCalendlyInZone = Extract<EmbededSlice, {variation: 'embededCalendly'}>;

    const props = defineProps(getSliceComponentProps<EmbededCalendlyInZone>());

    onMounted(() => {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        document.head.appendChild(script);
    });

    const calendlyUrl = computed(() => props.slice.primary.calendlyUrl || '');

    const isValidCalendlyUrl = computed(() => {
        if (!calendlyUrl.value) return false;
        const regex = /^https:\/\/calendly\.com\/[a-zA-Z0-9\-_]+(\/[a-zA-Z0-9\-_]+)?$/;
        return regex.test(calendlyUrl.value);
    });
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-embeded {
        &--embeded-calendly {
            .calendly-inline-widget {
                min-width: 320px;
                min-height: 680px;
            }

            .calendly-inline-widget iframe {
                @include mq.screen_sm() {
                    margin-top: var(--joy-core-spacing-7);
                }
            }
        }
    }
</style>
